import * as react from "react";
import * as reactDOM from "react-dom";
import { GlobalState } from "./globalState.js";
import { GraphEditor } from "./graphEditor.js";
import { RegisterToDisplayManagers } from "./graphSystem/registerToDisplayLedger.js";
import { RegisterToPropertyTabManagers } from "./graphSystem/registerToPropertyLedger.js";
import { RegisterTypeLedger } from "./graphSystem/registerToTypeLedger.js";
import { CreatePopup } from "shared-ui-components/popupHelper.js";
/**
 * Class used to create the Smart Filter Editor control
 */
export class SmartFilterEditorControl {
    /**
     * Show the node editor
     * @param options - defines the options to use to configure the node editor
     */
    static Show(options) {
        if (this._CurrentState) {
            if (this._PopupWindow) {
                this._PopupWindow.close();
            }
        }
        // Initial setup
        let hostElement = options.hostElement;
        if (!hostElement) {
            hostElement = CreatePopup("BABYLON.JS SMART FILTER EDITOR", {
                onWindowCreateCallback: (w) => {
                    this._PopupWindow = w;
                    // Styles are copied from the launching page which could have custom styles on the body tag,
                    //  and we require the body display to be block, so ensure that it is set as we need it.
                    w.document.body.style.display = "block";
                },
                width: 1500,
                height: 800,
            });
        }
        const globalState = new GlobalState(options.engine ?? null, options.onNewEngine ?? null, options.onSmartFilterLoadedObservable ?? null, options.optimizerEnabled ?? null, options.optimizerDebugMode ?? null, options.filter ?? null, options.blockEditorRegistration ?? null, hostElement, options.beforeRenderObservable ?? null, options.rebuildRuntime ?? null, options.reloadAssets ?? null, options.texturePresets ?? null, options.downloadSmartFilter, options.loadSmartFilterAsync, options.copySmartFilterToClipboard, options.copySmartFilterToStringAsync, options.pasteSmartFilterFromClipboardAsync, options.pasteSmartFilterFromStringAsync, options.saveToSnippetServer, options.addCustomBlock, options.deleteCustomBlock, options.clearCustomBlocks, options.onLogRequiredObservable, options.onSaveEditorDataRequiredObservable);
        RegisterToDisplayManagers(globalState);
        RegisterToPropertyTabManagers();
        RegisterTypeLedger();
        const graphEditor = react.createElement(GraphEditor, {
            globalState: globalState,
        });
        reactDOM.render(graphEditor, hostElement);
        this._CurrentState = globalState;
        globalState.hostWindow.addEventListener("beforeunload", () => {
            globalState.onPopupClosedObservable.notifyObservers();
        });
        // Close the popup window when the page is refreshed or scene is disposed
        if (globalState.smartFilter && options.engine && this._PopupWindow) {
            options.engine.onDisposeObservable.addOnce(() => {
                if (this._PopupWindow) {
                    this._PopupWindow.close();
                }
            });
            window.onbeforeunload = () => {
                if (this._PopupWindow) {
                    this._PopupWindow.close();
                }
            };
        }
    }
    static Hide() {
        if (this._PopupWindow) {
            this._PopupWindow.close();
        }
    }
}
//# sourceMappingURL=smartFilterEditorControl.js.map